class PrimaryNav {

  constructor(){
    this.navigationToggle = document.querySelector('[data-trigger="primary-nav"]');
    this.navigation       = document.querySelector('[data-target="primary-nav"]');
    this.navigationPanel  = document.querySelector('[data-target="primary-nav-panel"]');
    this._init();
  }

  _init(){

    document.addEventListener('DOMContentLoaded', (event) => {

      if(this.navigationToggle){
        this.navigationToggle.addEventListener('click', (event)=>this._updateNav(event) );
        this.navigationPanel.addEventListener('click', (event)=>event.stopPropagation() );
        window.addEventListener('click', ()=>this.navigation.setAttribute('data-state', 'closed') );
      }
    });
  }

  _updateNav(event){
    event.stopPropagation();
    this._toggleState(this.navigation, 'open', 'closed');
    this._toggleState(this.navigationToggle, 'open', 'closed');
  }

  _toggleState(elem, one, two){
    let newState = elem.getAttribute('data-state') === one ? two : one;
    elem.setAttribute('data-state', newState);
  }

}

export let primaryNav = new PrimaryNav();
